export default function getList(translationCache, keyword) {
  return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
}